import React from 'react';

import FareTrends from '@stencil/fare-trends';

import * as S from './FareTrendsUI.styles';

import ArrowLeftIcon from '../../../icons/ArrowLeft';
import ArrowRightIcon from '../../../icons/ArrowRight';

const FareTrendsUI = ({
  fareTrendsData,
  changeDateSelectedInFareTrends,
  departure,
  fareCalendarNextPreviousClick
}) => {
  const fareTrendWrapperStyle = {
    display: 'flex',
    width: '100%',
    height: '8.2em',
    overflow: 'hidden',
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 1px',
    marginBottom: '4px'
  };

  return (
    <S.FareTrendWrapper>
      <S.FareTrendInnerWrapper>
        <S.FareTrendArrowWrapperLt
          className="left"
          onClick={() => fareCalendarNextPreviousClick(false)}
        >
          <ArrowLeftIcon fill={'#000000'} loading="lazy" />
        </S.FareTrendArrowWrapperLt>
        <S.FareTrendArrowWrapperRt
          className="right"
          onClick={() => fareCalendarNextPreviousClick(true)}
        >
          <ArrowRightIcon fill={'#000000'} loading="lazy" />
        </S.FareTrendArrowWrapperRt>
        <S.TrendWrapper>
          <FareTrends
            fareTrendsData={fareTrendsData.slice(0, 15)}
            selectOtherDate={changeDateSelectedInFareTrends}
            selectedDate={departure.yyyymmdd}
            svgStyles={{ height: 100 }}
            svgHeight={90}
            lineHeight={80}
            dividerWidth={54}
            wrapperStyles={{ marginTop: 0 }}
            fareTrendWrapperStyle={{ fareTrendWrapperStyle }}
            maxHeightPercent={80}
            showMonth
            polyLineStyles={{
              fill: 'none',
              stroke: '#2276e3',
              strokeWidth: '1.7',
              animation: 'dash 0.7s linear'
            }}
            // datePostValCompare={50}
            lineAttributes={{ strokeWidth: '2', stroke: '#fff', fill: 'none' }}
            circleAttributes={{ r: '4', strokeWidth: '1.5' }}
            selectedDividerAttr={{ fill: '#9cc7ff', opacity: '0.4' }}
            otherDividerAttr={{ opacity: '0.4', fill: '#efefef' }}
          />
        </S.TrendWrapper>
      </S.FareTrendInnerWrapper>
    </S.FareTrendWrapper>
  );
};

export default FareTrendsUI;
